import React, { useEffect, useState } from 'react';
import { App, Modal, Radio, Space } from 'antd';
import { useUserProvider } from '@/context/UserProvider';
import styles from './index.module.less';
import { fetchHairstyleBloggerReport } from '@/lib/service';

interface ReportModalProps {
  visible: boolean;
  onClose: () => void;
  nickname?: string;
  libId?: number;
}

const ReportModal: React.FC<ReportModalProps> = ({ visible, onClose, nickname, libId }) => {
  const { isLogin, onOpenLoginModal } = useUserProvider();
  const { message } = App.useApp();
  const [reportReason, setReportReason] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 576);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleReport = () => {
    if (!reportReason) {
      message.error('Please select a reason for reporting');
      return;
    }
    if (!isLogin) {
      onOpenLoginModal(true);
      return;
    }
    if (reportReason === 'intellectual') {
      // 跳转外部链接
      handleClose();
      window.open('https://forms.gle/Y5bEefD4tBoKSbaX7', '_blank');
      return;
    }

    setLoading(true);
    fetchHairstyleBloggerReport({ nickname, lib_id: libId, reason: reportReason })
      .then((res) => {
        if (res?.code === 0) {
          message.success('Report submitted successfully');
          handleClose();
        }
      })
      .catch((e) => {
        message.error(e?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClose = () => {
    setReportReason('');
    onClose();
  };

  return (
    <Modal
      title="Report"
      open={visible}
      onOk={handleReport}
      onCancel={handleClose}
      okText={loading ? 'Reporting...' : 'Report'}
      cancelText="Cancel"
      className={styles.reportModal}
      centered
      width={540}
      confirmLoading={loading}
    >
      <Radio.Group onChange={(e) => setReportReason(e.target.value)} value={reportReason}>
        <Space direction="vertical" size={isMobile ? 12 : 16}>
          <div>
            <Radio value="offensive">Offensive</Radio>
            <div className={styles.subText}>Insensitive Content Or Inappropriate Imagery</div>
          </div>
          <div>
            <Radio value="misleading">Misleading</Radio>
            <div className={styles.subText}>Low Quality Or Spam</div>
          </div>
          <div>
            <Radio value="prohibited">Prohibited</Radio>
            <div className={styles.subText}>Products Or Services Not Allowed</div>
          </div>
          <div>
            <Radio value="mature">Mature</Radio>
            <div className={styles.subText}>Alcohol And Adult Products</div>
          </div>
          <div>
            <Radio value="exploitation">Exploitation</Radio>
            <div className={styles.subText}>Nudity, Non-Nudity Or Intentional Misuse Involving Minors</div>
          </div>
          <div>
            <Radio value="weapons">Weapons</Radio>
            <div className={styles.subText}>Weapons And Explosives</div>
          </div>
          <div>
            <Radio value="healthcare">Restricted Healthcare</Radio>
            <div className={styles.subText}>Medication Or Regulated Medical</div>
          </div>
          <div>
            <Radio value="intellectual">My Intellectual Property</Radio>
            <div className={styles.subText}>Copyright Or Trademark Infringement</div>
          </div>
          <div>
            <Radio value="promotion">Misleading Promotion</Radio>
            <div className={styles.subText}>Promo Code Not Working, Misleading Pricing Or Promotion Has Expired</div>
          </div>
        </Space>
      </Radio.Group>
    </Modal>
  );
};

export default ReportModal;
